import {
    InitPaymentRequest, initPaymentResponse,
    PaymentDetailRequest,
    PaymentDetailResponse,
    VPOSActionsEnum
} from "./payment.types";

const { REACT_APP_PAYMENT_SERVICE } = process.env;

export async function initPayment(payload: InitPaymentRequest, errorHandler: (e: any) => void, action:VPOSActionsEnum=VPOSActionsEnum.init) {
    try {
        const res = await fetch(`${REACT_APP_PAYMENT_SERVICE}`, {
            body: JSON.stringify({
                action,
                payload,
            }),
            headers: {
                'Content-type': 'application/json',
            },
            method: 'POST',
        }).then(res => res.json());

        return res.data as initPaymentResponse;
    }  catch (e) {
        console.log('e ::', e);
        errorHandler(e);
    }
}

export class PaymentDetailsError extends Error {
    constructor(public readonly reason: 'timeout' | 'network' | 'server', message: string) {
        super(message);
        this.name = 'PaymentDetailsError';
    }
}

/** How long the back page waits for the payment service before giving up. */
export const PAYMENT_DETAILS_TIMEOUT_MS = 20_000;

/**
 * Fetches payment details after Ameria redirects the customer back.
 * Unlike initPayment this throws on failure so the caller can show an error
 * instead of leaving the customer on an endless loader.
 */
export async function getPaymentDetails(payload: PaymentDetailRequest): Promise<PaymentDetailResponse> {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), PAYMENT_DETAILS_TIMEOUT_MS);

    try {
        const res = await fetch(`${REACT_APP_PAYMENT_SERVICE}`, {
            body: JSON.stringify({
                payload,
                action: VPOSActionsEnum.detail,
            }),
            headers: {
                'Content-type': 'application/json',
            },
            method: 'POST',
            signal: controller.signal,
        });

        if (!res.ok) {
            throw new PaymentDetailsError('server', `Payment service responded with ${res.status}`);
        }

        const body = await res.json();
        if (!body?.data) {
            throw new PaymentDetailsError('server', 'Payment service returned no data');
        }

        return body.data as PaymentDetailResponse;
    } catch (e) {
        if (e instanceof PaymentDetailsError) throw e;
        if ((e as Error)?.name === 'AbortError') {
            throw new PaymentDetailsError('timeout', 'Payment service did not respond in time');
        }
        throw new PaymentDetailsError('network', (e as Error)?.message || 'Network error');
    } finally {
        clearTimeout(timer);
    }
}
